export const GIFT_CARD_SKU_LIST = [
  "411619010101",
  "411632010101",
  "411634010101",
  "411635010101",
  "411637010101",
  "411640010101",
  "411642010101",
  "411644010101",
];

export const MODAL_TEXT = {
  TITLE: "Cadeaubon Bestelling",
  DESCRIPTION:
    "Voeg geen andere producten toe bij het bestellen van een cadeaubon. Gelieve deze af te rekenen in een aparte bestelling.",
};

export const MODAL_TEXT_GIFT_CARD = {
  TITLE: "Cadeaubon in winkelmand",
  DESCRIPTION: "Maximum één cadeaubon per bestelling.",
};

export const BASKET_COUNT = 1;



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/product/detail/constants.js